module.exports = __webpack_public_path__ + "static/img/img-features-feature-2-game-6.b004feb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-2-game-6.png
// module id = NWf7
// module chunks = 18